<ul>
  <li>
    <a [href]="authService.getDatenschutzPfad()" target="_blank" rel="noopener" style="text-decoration: none; color: inherit;">Datenschutzbedingungen</a>
  </li>
  <li routerLink="/imprint">Impressum</li>
  <!--<li routerLink="/procedural-instructions/dashboard">Nutzungsbedingungen</li>-->
</ul>
